// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"8ca667b4","506":"ff3b3044","567":"ff3b3044","902":"6a1f4ca4"}[chunkId] + ".chunk.css";
};